{
  "WHATSAPP_TEMPLATES": {
    "MODAL": {
      "TITLE": "Mẫu Whatsapp",
      "SUBTITLE": "Chọn mẫu whatsapp bạn muốn gửi",
      "TEMPLATE_SELECTED_SUBTITLE": "Configure template: {templateName}"
    },
    "PICKER": {
      "SEARCH_PLACEHOLDER": "Tìm kiếm Mẫu",
      "NO_TEMPLATES_FOUND": "Không tìm thấy mẫu nào cho",
      "HEADER": "Header",
      "BODY": "Body",
      "FOOTER": "Footer",
      "BUTTONS": "Buttons",
      "CATEGORY": "Loại",
      "MEDIA_CONTENT": "Media Content",
      "MEDIA_CONTENT_FALLBACK": "media content",
      "NO_TEMPLATES_AVAILABLE": "No WhatsApp templates available. Click refresh to sync templates from WhatsApp.",
      "REFRESH_BUTTON": "Refresh templates",
      "REFRESH_SUCCESS": "Templates refresh initiated. It may take a couple of minutes to update.",
      "REFRESH_ERROR": "Failed to refresh templates. Please try again.",
      "LABELS": {
        "LANGUAGE": "Ngôn ngữ",
        "TEMPLATE_BODY": "Nội dung của Mẫu",
        "CATEGORY": "Loại"
      }
    },
    "PARSER": {
      "VARIABLES_LABEL": "Biến",
      "LANGUAGE": "Ngôn ngữ",
      "CATEGORY": "Loại",
      "VARIABLE_PLACEHOLDER": "Nhập giá trị {variable}",
      "GO_BACK_LABEL": "Quay lại",
      "SEND_MESSAGE_LABEL": "Gửi tin nhắn",
      "FORM_ERROR_MESSAGE": "Vui lòng điền vào tất cả các biến trước khi gửi",
      "MEDIA_HEADER_LABEL": "{type} Header",
      "OTP_CODE": "Enter 4-8 digit OTP",
      "EXPIRY_MINUTES": "Enter expiry minutes",
      "BUTTON_PARAMETERS": "Button Parameters",
      "BUTTON_LABEL": "Button {index}",
      "COUPON_CODE": "Enter coupon code (max 15 chars)",
      "MEDIA_URL_LABEL": "Enter {type} URL",
      "DOCUMENT_NAME_PLACEHOLDER": "Enter document filename (e.g., Invoice_2025.pdf)",
      "BUTTON_PARAMETER": "Enter button parameter"
    }
  }
}
